export const cityScraperList = ["jacksonville"];
